export const cityScraperList = ["jacksonville"];
